module.exports = __webpack_public_path__ + "img/android-chrome-256x256.e8f46453.png";